import { adminJson } from "./adminHttp";

function enc(v) {
  return encodeURIComponent(String(v ?? ""));
}

function getAdminMe() {
  try {
    const raw = localStorage.getItem("admin_me");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function withAdminId(path) {
  const me = getAdminMe();
  const adminId = me?.id;
  if (!adminId) return path;
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}adminId=${enc(adminId)}`;
}

function qs(params = {}) {
  const out = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    out.set(key, String(value));
  });
  return out.toString();
}

export function listOwnerTrackerCases(params = {}) {
  const query = qs(params);
  return adminJson(withAdminId(`/admin/tracker/owner-cases${query ? `?${query}` : ""}`));
}

export function getOwnerTrackerSummary() {
  return adminJson(withAdminId("/admin/tracker/owner-cases/summary"));
}

export function createOwnerTrackerCase(payload) {
  return adminJson(withAdminId("/admin/tracker/owner-cases"), {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
}

export function updateOwnerTrackerCase(id, payload) {
  return adminJson(withAdminId(`/admin/tracker/owner-cases/${enc(id)}`), {
    method: "PUT",
    body: JSON.stringify(payload || {}),
  });
}

export function deleteOwnerTrackerCase(id) {
  return adminJson(withAdminId(`/admin/tracker/owner-cases/${enc(id)}`), {
    method: "DELETE",
  });
}

export function listPhoneTrackerMembers(params = {}) {
  const query = qs(params);
  return adminJson(withAdminId(`/admin/tracker/phone-members${query ? `?${query}` : ""}`));
}

export function getPhoneTrackerSummary() {
  return adminJson(withAdminId("/admin/tracker/phone-members/summary"));
}

export function createPhoneTrackerMember(payload) {
  return adminJson(withAdminId("/admin/tracker/phone-members"), {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
}

export function updatePhoneTrackerMember(id, payload) {
  return adminJson(withAdminId(`/admin/tracker/phone-members/${enc(id)}`), {
    method: "PUT",
    body: JSON.stringify(payload || {}),
  });
}

export function deletePhoneTrackerMember(id) {
  return adminJson(withAdminId(`/admin/tracker/phone-members/${enc(id)}`), {
    method: "DELETE",
  });
}
